import { useEffect, useRef } from 'react';

const MonthPicker = ({ placeholder, onDateChange }) => {
    const inputRef = useRef(null);
    const flatpickrInstance = useRef(null);

    useEffect(() => {
        if (window.flatpickr && window.flatpickr.l10ns && inputRef.current) {
            if (flatpickrInstance.current) {
                flatpickrInstance.current.destroy();
            }

            window.flatpickr.localize(window.flatpickr.l10ns.tr);

            flatpickrInstance.current = window.flatpickr(inputRef.current, {
                locale: 'tr',
                dateFormat: "Y-m",
                altInput: true,
                altFormat: "F Y",
                plugins: [
                    new window.monthSelectPlugin({
                        shorthand: false,
                    }),
                ],
                onChange: function (selectedDates, dateStr) {
                    if (selectedDates.length > 0) {
                        const date = selectedDates[0];
                        const year = date.getFullYear();
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const formattedDate = `${year}-${month}`;
                        onDateChange(formattedDate);
                    } else {
                        onDateChange('');
                    }
                },
            });
        }

        return () => {
            if (flatpickrInstance.current) {
                flatpickrInstance.current.destroy();
                flatpickrInstance.current = null;
            }
        };
    }, []);

    return (
        <input 
            ref={inputRef} 
            type="text" 
            className="form-control" 
            placeholder={placeholder}
            readOnly
        />
    );
};

export default MonthPicker;